<template>
  <div style="min-height: 100vh; overflow-y: scroll; background-color: #F1CAF9">
    <div v-if="showMask" class="mask" @click="closeMask"></div>
    <div
      v-if="showMask"
      class="special"
      style="background-image: url('img/magicPlace/special_tips.png')"
    >
      <div class="text_box">
         <div
        class="tip_text"
        style="background-image: url('img/magicPlace/special_text.png')"
      ></div>
      </div>
  </div>
    <div
      class="top_bg"
      style="background-image: url('img/magicPlace/top_bg.png')"
    >
    <div class="rank_btn"  @click="toRank">挑战榜</div>
      <div
        class="back_btn"
        style="background-image: url(img/cpRank/back_btn.png)"
        @click="closePage"
      ></div>
      <div
        class="tips"
        style="background-image: url('img/magicPlace/tips.png')"
        @click="showMask = true"
      ></div>
      <!-- <back-nav :icon="'img/backw.png'" :textColor="'#fff'" :backColor="'none'" /> -->
<!-- 
      <div
        class="notice"
        @click="toRank"
        style="background-image: url('img/magicPlace/notice_bg.png')"
        v-if="giftArr.length > 0"
      >
        <van-swipe :autoplay="2000" :height="27" :vertical="true">
          <van-swipe-item v-for="(item, index) in giftArr" :key="index">
            <template>
              恭喜<span class="nick_name">{{ item.nickname }}</span
              >在<span class="gold_name">{{ ranklist[rankCur].name }}</span
              >中获得了<span class="gift_name_">{{ item.gift_name }}</span>
            </template>
          </van-swipe-item>
        </van-swipe>
      </div> -->
      <div
        class="play_tips"
        style="background-image: url('img/magicPlace/play_tips.png')"
      ></div>
      <!-- <div class="roomNav">
        <template v-for="(item, index) in ranklist">
          <div
            class="room-title"
            v-if="item.show"
            :key="item.id"
            :style="
              rankCur == index
                ? 'background-image:url(' + item.navAcBg + ')'
                : 'background-image:url(' + item.navBg + ')'
            "
            @click="rankchange(index, item.id)"
          ></div>
        </template>
      </div> -->
    </div>
    <div
      class="bags_bg"
    >
      <div
        class="bronze_bag one_bag"
        style="background-image: url('img/magicPlace/egg_bg_1.png')"
      >
       <div class="bag_title" style="background-image: url('img/magicPlace/title_1.png')"></div>
        <!-- <div class="rate" v-if="level3.length>0" style="background-image: url('img/magicPlace/rate3.png');">{{'中奖率:'+level3[0].rate+'%'}}</div> -->
        <div class="gift_box">
          <div v-for="(item, index) in info1" :key="index" class="gift_content">
            <div
              class="gift_item"
             
            >
              <div
                class="sub_bg"
                style="background-image: url('img/magicPlace/sub_bg_1.png')"
              >
                <img class="gold" src="img/bi.png" alt="" />
                <span class="value">{{ item.diamonds }}</span>
              </div>
              <img class="gift_img" :src="item.gift_url" alt="" />
            </div>
            <div class="gift_name">{{ item.gift_name }}</div>
          </div>
        </div>
      </div>
      <div
        class="bronze_bag"
        style="background-image: url('img/magicPlace/egg_bg_2.png')"
      >
      <div class="bag_title" style="background-image: url('img/magicPlace/title_2.png')"></div>
        <!-- <div class="rate" v-if="level2.length>0" style="background-image: url('img/magicPlace/rate2.png');">{{'中奖率:'+level2[0].rate+'%'}}</div> -->
        <!-- <div class="bronze_title_bg" style="background-image: url('img/magicPlace/title2.png');"></div> -->
        <div class="gift_box">
          <div v-for="(item, index) in info2" :key="index" class="gift_content">
            <div
              class="gift_item"
            
            >
              <div
                class="sub_bg"
                style="background-image: url('img/magicPlace/sub_bg_1.png')"
              >
                <img class="gold" src="img/bi.png" alt="" />
                <span class="value">{{ item.diamonds }}</span>
              </div>
              <img class="gift_img" :src="item.gift_url" alt="" />
            </div>
            <div class="gift_name">{{ item.gift_name }}</div>
          </div>
        </div>
      </div>
      <div
        class="bronze_bag"
        style="background-image: url('img/magicPlace/egg_bg_3.png')"
      >
       <div class="bag_title" style="background-image: url('img/magicPlace/title_3.png')"></div>
        <div class="gift_box">
          <div v-for="(item, index) in info3" :key="index" class="gift_content">
            <div
              class="gift_item"
            >
              <div
                class="sub_bg"
                style="background-image: url('img/magicPlace/sub_bg_1.png')"
              >
                <img class="gold" src="img/bi.png" alt="" />
                <span class="value">{{ item.diamonds }}</span>
              </div>
              <img class="gift_img" :src="item.gift_url" alt="" />
            </div>
            <div class="gift_name">{{ item.gift_name }}</div>
          </div>
        </div>
      </div>
       <div
        class="bronze_bag"
        style="background-image: url('img/magicPlace/egg_bg_4.png')"
      >
       <div class="bag_title" style="background-image: url('img/magicPlace/title_4.png')"></div>
        <div class="gift_box">
          <div v-for="(item, index) in info4" :key="index" class="gift_content">
            <div
              class="gift_item"
             
            >
              <div
                class="sub_bg"
                style="background-image: url('img/magicPlace/sub_bg_1.png')"
              >
                <img class="gold" src="img/bi.png" alt="" />
                <span class="value">{{ item.diamonds }}</span>
              </div>
              <img class="gift_img" :src="item.gift_url" alt="" />
            </div>
            <div class="gift_name">{{ item.gift_name }}</div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import "@/assets/css/magicPlace.css";
import { starPlanInfo, serverPullMsg } from "@/api/api";
export default {
  data() {
    return {
      info1: [],
      info2: [],
      info3: [],
      info4: [],
      level1: [],
      level2: [],
      level3: [],
      listData: [],
      rankCur: 0,
      room_id: "",
      showMask: false,
      giftArr: [],
      showNotice: false,
      params: {
        type: 1,
        page: 1,
        rows: 15,
        gift_id: 493,
      },
    };
  },
  created() {
    let access_token = this.$route.query.access_token;
    localStorage.setItem("access_token", access_token);
    this.room_id = this.$route.query.room_id;
    this.getInfo();
    // this.getRank();
  },
  methods: {
    getInfo() {
      let params = {
        type: 1,
      };
      starPlanInfo(params).then((res) => {
         this.info1 = res.data.data[2].gift_info
        this.info2 = res.data.data[3].gift_info
        this.info3 = res.data.data[0].gift_info
        this.info4 = res.data.data[1].gift_info
      });
    },

 
 
     toRank() {
      this.$router.push({ path: "/magicPlaceRank?type=1" });
    },
    // getRank() {
    //   serverPullMsg(this.params)
    //     .then(
    //       (res) => {
    //         this.giftArr = res.data;
    //         console.log(this.giftArr);
    //       },
    //       (error) => {
    //         this.$toast.fail(error);
    //       }
    //     )
    //     .catch((error) => {
    //       this.$toast.fail(error);
    //     });
    // },
    closeMask() {
      this.showMask = false;
    },
    closePage() {
      let params = "调用";
      this.$bridge.callhandler("closePage", params, (data) => {
        // 处理返回数据
      });
    },
  },
};
</script>
   